import { render } from "./BaseButton.vue?vue&type=template&id=ed5c2136&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=ed5c2136&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed5c2136"

export default script